import { createContext } from "react"

import { Category, ColorLibObj, NodeLeaf } from "../../../utils/types"

interface ContextType {
  mapCoords: any
  colorLib: ColorLibObj[],
  xmlClasses: {[x: string]: Category[]}
  jsonClasses: {[x: string]: NodeLeaf[]}
  xmlNames: string[]
  xmlClassFilter: {[x: string]: string[]}
  jsonName: string
  jsonClassFilter: string
  resetMap: Function,
  sysClassFilter: string[]
  userFilter: number[]
  BCRScore: number | null
  imageWidth: number
  imageHeight: number
  imageZoomLvl: number
  bcrClassFilter: string[]
  readonly?: boolean,
  toggleLoading: Function
}

export const ViewerContext = createContext<ContextType>({
  mapCoords: null,
  colorLib: [],
  xmlClasses: {},
  jsonClasses: {},
  xmlNames: [],
  xmlClassFilter: {},
  jsonName: '',
  jsonClassFilter: '',
  resetMap: () => {},
  sysClassFilter: [],
  userFilter: [],
  BCRScore: null,
  imageWidth: 0,
  imageHeight: 0,
  imageZoomLvl: 0,
  bcrClassFilter: [],
  readonly: false,
  toggleLoading: () => {}
})